export const objectSearch = (search: string) => {
    const s = search.toLowerCase().trim();

    return (item: any): boolean => {
        if (!s) {
            return true;
        }

        if (item === null) {
            return false;
        }

        if (typeof item === 'string') {
            return item.toLowerCase().includes(s);
        }

        if (typeof item === 'object') {
            return Object.values(item).some(value =>
                typeof value === 'string' ? value.toLowerCase().includes(s) : false
            );
        }

        return false;
    };
};
